<template>
    <div ref="container" class="d-flex flex-column container mt-3">
        <email-verification 
            ref='emailVerification' 
            :item='item' 
            v-on:validated='updateItem($event)' />
        <password-verification 
            ref='passwordVerification' 
            :item='item' 
            v-on:validated='(current_password) => {item.current_password = current_password; validateEmail($event)}' />
        <loading ref="loading"></loading>
        <header class="text-center">
            <h1 class="h2">{{ $t('translations.edit_my_details')}}</h1>
            <p>{{ $t('translations.remember_to_click_save_below')}}</p>
        </header>
        <div ref="editScroller" class="card-default-mtb-0 flex-grow-1-scroll">
            <div>
                <local-error v-bind:inline='["title",
                "forenames",
                "surname",
                "email",
                "address_line_1",
                "address_line_2",
                "address_line_3",
                "address_line_4",
                "postcode",
                "dob",
                "gender",
                "phone_number",
                "phone_number_alt",
                "provider.site_id",
                "nhs_number",
                "current_password",
                "new_password",
                ]'></local-error>


                <div class="form-group">
            		<label for='title'>{{ $t('translations.title')}}</label>
            		<select v-model='item.user_title_id' class='form-control' id="title">
                        <option disabled value="">{{ $t('translations.please_select')}}</option>
                        <option v-for="(value, key) in $root.lookup.user_titles" :value="key" :key="key">{{$t('translations.'+ value)}}</option>
                    </select>
                    <inline-error type='user_title_id'></inline-error>
            	</div>

                <div class="form-row">
                    <div class="form-group col">
                        <label for='fornames'>{{ $t('translations.forename(s)')}} <span class="required-field">*</span></label>
                        <input type='text' v-model='item.forenames' class='form-control' id="fornames">
                        <inline-error type='forenames'></inline-error>
                    </div>

                    <div class="form-group col">
                        <label for='surname'>{{ $t('translations.surname')}} <span class="required-field">*</span></label>
                        <input type='text' v-model='item.surname' class='form-control' id="surname">
                        <inline-error type='surname'></inline-error>
                    </div>
                </div>

                <div class="form-group">
            		<label for='email'>{{ $t('translations.email')}} <span class="required-field">*</span></label>
            		<input type='email' v-model='item.email' class='form-control' id="email">
                    <inline-error type='email'></inline-error>
            	</div>

                <hr>
                <div v-if='!show_password_change' class="form-group">
                    <button class='btn btn-primary' v-on:click.prevent='show_password_change = true'>{{$t('translations.change_password')}}</button> 
                </div>
                
                <template v-else>
					<div v-if='$root.user.egl_profile_id' class='m-3 alert alert-warning text-dark'>
						{{ this.autobrand("translations.linked_account_password_information") }}
					</div>

                    <div class="form-group">
                        <password
                            :title="$t('translations.current_password')"
                            :required='false'
                            :show_strength='false'
                            v-bind:errors='errors' 
                            v-bind:email='item.email'
                            v-bind:forenames='item.forenames'
                            v-bind:surname='item.surname'
                            v-bind:passwordfield.sync='item.current_password'
                            password_error_name="current_password"
                        ></password>
                    </div>
                    <div class="form-group">
                        <password 
                            :title="$t('translations.new_password')"
                            :required='false'
                            v-bind:errors='errors' 
                            v-bind:email='item.email' 
                            v-bind:forenames='item.forenames'
                            v-bind:surname='item.surname'
                            v-bind:passwordfield.sync='item.new_password'
                            password_error_name="new_password">
                        </password>
                    </div>
                    
                </template>
                <hr>
                <div class="form-group">
            		<label for='address_line_1'>{{ $t('translations.address_line_1')}}</label>
            		<input type='text' v-model='item.address_line_1' class='form-control' id="address_line_1">
                    <inline-error type='address_line_1'></inline-error>
            	</div>

                <div class="form-group">
            		<label for='address_line_2'>{{ $t('translations.address_line_2')}}</label>
            		<input type='text' v-model='item.address_line_2' class='form-control' id="address_line_2">
                    <inline-error type='address_line_2'></inline-error>
            	</div>

                <div class="form-group">
                    <label for='address_line_3'>{{ $t('translations.address_line_3')}}</label>
                    <input type='text' v-model='item.address_line_3' class='form-control' id="address_line_3">
                    <inline-error type='address_line_3'></inline-error>
                </div>

                <div class="form-group">
                    <label for='address_line_4'>{{ $t('translations.address_line_4')}}</label>
                    <input type='text' v-model='item.address_line_4' class='form-control' id="address_line_4">
                    <inline-error type='address_line_4'></inline-error>
                </div>

                <div class="form-group">
                    <label for='postcode'>{{ $t('translations.postcode')}} <span class="required-field">*</span></label>
                    <input type='text' v-model='item.postcode' class='form-control text-uppercase' id="postcode">
                    <inline-error type='postcode'></inline-error>
                </div>

                <div class="form-group">
            		<label for='dob'>{{ $t('translations.date_of_birth')}}</label>
                    <vue-dob-picker show-labels='true' v-model='item.dob' id='dob'/>
            		<!-- <input type='date' v-model='item.dob' class='form-control'> -->
                    <inline-error type='dob'></inline-error>
            	</div>

                <div class="form-group">
            		<label for='gender'>{{ $t('translations.gender')}} <span class="required-field">*</span></label>
            		<select v-model='item.gender' class='form-control' id="gender">
                        <option disabled value="">{{ $t('translations.please_select')}}</option>
                        <option v-for="(value, key) in $root.lookup.genders" :value="key" :key="key">{{$t(value)}}</option>
                    </select>
                    <inline-error type='gender'></inline-error>
            	</div>

                <div class="form-group">
                    <label for='phone_number'>{{ $t('translations.phone_number')}}</label>
                    <input type='tel' v-model='item.phone_number' class='form-control' id="phone_number">
                    <inline-error type='phone_number'></inline-error>
                </div>

                <div class="form-group">
                    <label for='phone_number_alt'>{{ $t('translations.alternative_phone_number')}}</label>
                    <input type='tel' v-model='item.phone_number_alt' class='form-control' id="phone_number_alt">
                    <inline-error type='phone_number_alt'></inline-error>
                </div>

                <div v-if='$root.provider && $root.provider.site && $root.provider.site.length && item && item.provider' class="form-group">
                    <b-form-group :label="$t('translations.preferred_site')">
                    <b-form-radio-group
                              buttons
                              stacked
                              value-field='id'
                              text-field='name'
                              v-model="item.provider.site_id"
                              :options="$root.provider.site"
                              class='btn-block'
                              button-variant="card-radio"
                              name="site_id" />
                    </b-form-group>
                    <inline-error type='provider.site_id'></inline-error>
                </div>


                <div class="locale-changer mr-2 form-group"  v-if='environment_settings.MIX_ENABLE_LANGUAGE_SELECTION'>
                    <label for="set_default_language">{{ $t('translations.set_default_language')}}</label>
                    <select class="form-control custom-select" v-model="item.locale" v-on:change="setLocale" id="set_default_language">
                        <option :key='key' v-for="(lang, key) in $root.lookup.langs" :value="key" placeholder="language">{{ lang }}</option>
                    </select>
                </div>

                <!-- <div class="form-group">
                    <label for='nhs_number'>{{$t('translations.NHS_number')}}</label>
                    <input v-on:keyup='formatNhsNumber(item.nhs_number)' type='text' v-model='item.nhs_number' class='form-control' id="nhs_number">
                    <inline-error type='nhs_number'></inline-error>
                </div> -->

                <div v-if='item.preferred_clinician' class="form-group">
                    <label for='preferred_clinician'>{{ $t('translations.usual_GP')}}</label>
                    <div v-text='formatNameCompliant(item.preferred_clinician)'></div>
                    <!-- <select class="form-control" v-model='item.preferred_clinician_id'>
                        <option v-for="user in $root.lookup.staff" :key='user.id' :value='user.id' v-text='formatNameCompliant(user)'></option>
                    </select> -->
                </div>

                <!-- Removed whilst we consider how this is handled in the EGL app -->
                <!-- <div v-if='Array.isArray(item.oauth_clients) && item.oauth_clients.length' class="form-group">
                    <label>{{ $t('translations.third_party_apps_account_access')}}</label>
                    <div style='border: 1px solid #676F89; padding: 0.375rem 0.75rem' :key='client.id' v-for='client in item.oauth_clients' class='d-flex flex-row'><div class='flex-grow-1 align-self-center'>{{ client.name }}</div><div><button v-on:click.stop='revokeOauthClient(client)' class='btn-sm btn-warning btn-block btn-round'>{{ $t('translations.oauth_revoke_access') }}</button></div></div>
                </div> -->

                <button class="btn btn-primary btn-block btn-round" v-on:click.prevent='validateItem' role="button">{{ $t('translations.confirm')}}</button>
            </div>
        </div>




            <!-- <button class="btn btn-primary" v-on:click.prevent='closePanel(false)' role="button">Cancel</button> -->

    </div>
</template>

<script>
	export default {
		props: [
		],
		data: function(){
			return {
                errors: [],
                item: {
                    current_password: "",
                    new_password: "",
                    forenames: "",
                    surname: "",
                    address_line_1: "",
                    address_line_2: "",
                    address_line_3: "",
                    address_line_4: "",
                    dob: "",
                    locale: "",
                    email: "",
                    oauth_clients: [],
                },
                show_password_change: false,
			};
		},
        computed: {

        },
        mounted() {
            this.setLoading(true);
            
            this.mergeUpdateItem(this.item, this.copyNonReactive(this.$root.user), []);

            this.item.current_password = "";
            this.item.new_password = "";

            this.item.provider = {
                id: this.item.provider.id,
                site_id: this.item.provider.site_id
            }
            delete(this.item.user_provider);
            delete(this.item.carees);
            delete(this.item.carers);

            axios.get('/api/vp1/patients/getOauthClients').then((res) => {
                this.setLoading(false);
                this.item.oauth_clients = res.data;
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "load");
                this.$router.push({path: "/"});
            });
        },
        methods : {
            validateItem(event) {
                if(this.item.email == this.$root.user.email) {
                    this.updateItem(event);
                }
                else if(this.item.current_password) {
                    this.setLoading(true);
                    return axios.post('/api/vp1/patients/updateValidate', this.item).then((res) => {
                        this.errors = [];
                        this.setLoading(false);
                        this.validateEmail(event);
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "update");
                        this.scrollFirstError();
                    });
                    
                }
                else {
                    this.setLoading(true);
                    return axios.post('/api/vp1/patients/updateValidateNoCP', this.item).then((res) => {
                        this.errors = [];
                        this.setLoading(false);
                        this.$refs.passwordVerification.show();
                    }).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "update");
                        this.scrollFirstError();
                    });
                }
            },
            validateEmail(event) {
                this.$refs.emailVerification.getEmailVerificationCode();
            },
            updateItem(event) {

                if(this.$root.provider && this.$root.provider.site && this.$root.provider.site.length == 1) {
                    this.item.provider.site_id = this.$root.provider.site[0].id;
                }
                this.setLoading(true);
                axios.put('/api/vp1/patients/' + this.item.id, this.item).then((res) => {
                    this.errors = [];
                    this.item.current_password = "";
                    this.item.new_password = "";
                    this.show_password_change = false;
                    
                    // If we reset our password, we need the new api_token
                    if(res.data.api_token) {
                        window.api_token = res.data.api_token;
                        this.$root.api_token = window.api_token;
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.api_token;
                    }

					this.setLoading(false);
                    this.addNotification({type: "success", content: this.$t('translations.your_user_details_were_updated_successfully')});
                    this.$root.loadCore(false);

				}).catch((error) => {
                    console.log("error: " + JSON.stringify(error, null, 2));
                    this.setLoading(false);
                    this.handleError(error, "update");
                    this.scrollFirstError();
                });
            },
            setLocale() {
                Vue.nextTick(() => {
                    this.$root.setLocale(this.item.locale);
                });
            },
            revokeOauthClient(client) {
                this.$modal.show('dialog', {
                    title: this.$t('translations.remove_access'),
                    text: this.autobrand('translations.remove_access_confirmation', {client: client.name}),
                    buttons: [
                    {
                        title: this.$t('translations.okay'),
                        handler: () => {
                            this.$modal.hide('dialog');
                            
                            axios.delete(this.$root.apiBase + '/patients/revokeClient/' + client.id).then((res) => {
                                this.item.oauth_clients.splice(this.item.oauth_clients.findIndex(obj => {return obj.id == client.id}), 1);
                            }).catch(error => {
                                this.setLoading(false);
                                this.handleError(error, "revoke");
                            });
                        },
                        default: true
                    },
                    {
                        title: this.$t('translations.cancel'),
                        handler: () => {
                            this.$modal.hide('dialog');
                        }
                    }]});
            }

        }
    }
</script>
